import { render, staticRenderFns } from "./NvShelf.vue?vue&type=template&id=50ed6562&scoped=true&"
import script from "./NvShelf.vue?vue&type=script&lang=js&"
export * from "./NvShelf.vue?vue&type=script&lang=js&"
import style0 from "./NvShelf.vue?vue&type=style&index=0&id=50ed6562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ed6562",
  null
  
)

export default component.exports